module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Adminlte', [_vm._v("\n  Welcome Admin!\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-376f4e91","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/Home.vue
// module id = 717
// module chunks = 1